import React, { useEffect, useRef, useState } from "react";
import SnackChip from "../SnackChip/SnackChip";
import {
  getLocalTranslation,
  useComponentVisibles,
} from "../../utils/functions";
import EditSvg from "../../assets/img/edit.svg";
import { useTranslation } from "react-i18next";

import CustomCheckbox from "../Forms/FormInput/CustomCheckbox/CustomCheckbox";
import {
  PopulatedResource,
  ResourceBackgroundColor,
} from "../../models/LibraryModels";
import {
  getColorbyKey,
  getResourcesImg,
} from "../../assets/img/resources/resources";
import { ITemplateButtonOptions } from "../../pages/Survey/Template/TemplatePage";

require("./CardLibrary.scss");

interface ICardresource {
  buttonsOption?: Array<ITemplateButtonOptions>;
  resources: PopulatedResource[];
  reosurce?: PopulatedResource;
  onChangeImage?: (value?: PopulatedResource) => void;
}

export const CardLibrary = ({
  buttonsOption,
  onChangeImage,
  resources,
  reosurce,
}: ICardresource) => {
  const refs = useRef<(HTMLDivElement | null)[]>([]);
  const handleRefAssignment =
    (index: number) => (ref: HTMLDivElement | null) => {
      refs.current[index] = ref;
    };

  const { isComponentVisible, setComponentVisible } = useComponentVisibles(
    false,
    refs
  );
  const [isChecked, setIsChecked] = useState<string | undefined>(reosurce?.id);

  useEffect(() => {}, [isChecked, reosurce, resources]);

  const { t } = useTranslation();
  const optionsButton = (indexData: number) => {
    const handleOptionClick = (optionIndex: number) => {
      const option = buttonsOption && buttonsOption[indexData][optionIndex];
      if (option && option.onClick) {
        setComponentVisible(indexData);
        option.onClick(indexData);
      }
    };

    return (
      <div
        key={indexData}
        className="table-options-menu"
        ref={handleRefAssignment(indexData)}
      >
        <div className="container-wrapper-options">
          <div
            className="wrapper-options"
            onClick={() => {
              setComponentVisible(indexData);
            }}
          >
            <img src={EditSvg} alt="edit"></img>
          </div>
          <div
            className={`container-options ${
              isComponentVisible[indexData] ? "open" : ""
            }`}
          >
            {buttonsOption![indexData].map(
              ({ label, onClick, colorTheme, icon, isLoading }, index) => (
                <div className="item-options " key={index}>
                  <div
                    key={index}
                    onClick={() => {
                      handleOptionClick(index);
                    }}
                    className={`menu-item menu-item-${colorTheme}`}
                  >
                    <span
                      className={`icon  icon-button-table color-${colorTheme}`}
                    >
                      {icon}
                    </span>
                    <span
                      className={`capitalize-first-letter color-${colorTheme}`}
                    >
                      {label}
                    </span>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {resources?.map((resource, index) => {
        return (
          <div
            key={resource.id}
            className=" col-lg-4 col-xl-3 card-library-container"
          >
            <div className="card-wrapper">
              <div>
                <div className="wrapper-info">
                  <div className="container-image">
                    <img
                      alt={resource?.type as unknown as string}
                      className="img-library"
                      src={getResourcesImg(resource?.type as unknown as string)}
                    ></img>
                  </div>
                </div>
                <div className="info-library">
                  <div className="wrapper-chip-name">
                    <div className="wrapper-chip">
                      <div className="container-chip">
                        <SnackChip
                          backgroundColor={getColorbyKey(
                            resource?.type as keyof typeof ResourceBackgroundColor
                          )}
                          theme="resource"
                          color="white"
                          borderRadius="sm"
                          label={t(`selectOptions.${resource?.type}`)}
                        />
                      </div>
                      {resource.isIssueLinked && (
                        <div className="container-chip">
                          <SnackChip
                            label=""
                            borderRadius="sm"
                            iconLeft={"icon-issue"}
                            theme="is-linked-issue"
                          />
                        </div>
                      )}
                    </div>

                    <div className="library-name">
                      {resource.translations &&
                        getLocalTranslation(resource.translations).title}
                    </div>
                  </div>
                  <div className="library-description">
                    {resource.translations &&
                      getLocalTranslation(resource.translations).description}
                  </div>
                </div>
              </div>
              <div className="library-footer">
                <div className="wrapper-like">
                  {resource.nLikes >= 0 && (
                    <>
                      <i className="icon icon-heart"></i>
                      <span>{resource.nLikes}</span>
                    </>
                  )}
                </div>

                <>
                  {buttonsOption ? (
                    optionsButton(index)
                  ) : (
                    <CustomCheckbox
                      label=""
                      checked={resource.id === isChecked}
                      onChange={() => {
                        onChangeImage && onChangeImage(resource);
                        setIsChecked(resource.id);
                      }}
                    />
                  )}
                </>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
